import React, { FC, useEffect, useRef } from 'react'
import './update-modal.css'

// COMPONENTS
import Button from '@components/atoms/button'

// UTILITIES
import { flatten } from '@utils/string-helper'


interface Props extends React.HTMLAttributes<HTMLDialogElement> {
    update(): void
}

const UpdateModal: FC<Props> = (props) => {
    const { className: classProp, update, ...divProps } = props
    const className = flatten('update-modal', classProp)
    const ref = useRef<HTMLDialogElement>(null)

    useEffect(() => {
        if (ref.current) ref.current.showModal()
    }, [ref.current])

    return (
        <dialog ref={ref} className={className} {...divProps}>
            <div>
                <form className="flex flex-col items-stretch" method="dialog">
                    <h2>Update Now</h2>
                    <p>We've made improvements to the app. Please update to continue.</p>
                    <Button type="submit" onClick={update}>Update</Button>
                </form>
            </div>
        </dialog>
    )
}

export default UpdateModal
